import { FC } from "react";
import type { IndicatorName, IndicatorSettings, AcceleratorOscillatorSettings, ADXSettings, AlligatorSettings, AroonSettings, BollingerBandsSettings, DonchianChannelSettings, FractalSettings, FractalChaosBandsSettings, IchimokuKinkoHyoSettings, MACDSettings, OsMASettings, ParabolicSARSettings, RSISettings, StochasticOscillatorSettings, SuperTrendSettings, ZigZagSettings } from "../../model";
import * as Tabs from "./indicatorTabComponents";

type Tab = "inputs" | "styles";

interface Props {
  activeTab: Tab;
  indicatorName: IndicatorName;
  settings: IndicatorSettings;
  onChange: (s: IndicatorSettings) => void;
}

export const IndicatorTabContent: FC<Props> = ({ activeTab, indicatorName, settings, onChange }) => {
  if (indicatorName === "acceleratorOscillator") {
    const s = settings as AcceleratorOscillatorSettings;
    if (activeTab === "inputs") return <Tabs.AcceleratorOscillatorInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.AcceleratorOscillatorStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "aDX") {
    const s = settings as ADXSettings;
    if (activeTab === "inputs") return <Tabs.ADXInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.ADXStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "donchianChannel") {
    const s = settings as DonchianChannelSettings;
    if (activeTab === "inputs") return <Tabs.DonchianChannelInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.DonchianChannelStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "bollingerBands") {
    const s = settings as BollingerBandsSettings;
    if (activeTab === "inputs") return <Tabs.BollingerBandsInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.BollingerBandsStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "aroon") {
    const s = settings as AroonSettings;
    if (activeTab === "inputs") return <Tabs.AroonInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.AroonStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "alligator") {
    const s = settings as AlligatorSettings;
    if (activeTab === "inputs") return <Tabs.AlligatorInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.AlligatorStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "fractal") {
    const s = settings as FractalSettings;
    if (activeTab === "inputs") return <Tabs.FractalInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.FractalStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "fractalChaosBands") {
    const s = settings as FractalChaosBandsSettings;
    if (activeTab === "inputs") return <Tabs.FractalChaosBandsInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.FractalChaosBandsStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "ichimokuKinkoHyo") {
    const s = settings as IchimokuKinkoHyoSettings;
    if (activeTab === "inputs") return <Tabs.IchimokuKinkoHyoInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.IchimokuKinkoHyoStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "mACD") {
    const s = settings as MACDSettings;
    if (activeTab === "inputs") return <Tabs.MACDInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.MACDStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "osMA") {
    const s = settings as OsMASettings;
    if (activeTab === "inputs") return <Tabs.OsMAInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.OsMAStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "parabolicSAR") {
    const s = settings as ParabolicSARSettings;
    if (activeTab === "inputs") return <Tabs.ParabolicSARInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.ParabolicSARStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "superTrend") {
    const s = settings as SuperTrendSettings;
    if (activeTab === "inputs") return <Tabs.SuperTrendInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.SuperTrendStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "zigZag") {
    const s = settings as ZigZagSettings;
    if (activeTab === "inputs") return <Tabs.ZigZagInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.ZigZagStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "rSI") {
    const s = settings as RSISettings;
    if (activeTab === "inputs") return <Tabs.RSIInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.RSIStylesTab settings={s} onChange={onChange} />;
  }
  if (indicatorName === "stochasticOscillator") {
    const s = settings as StochasticOscillatorSettings;
    if (activeTab === "inputs") return <Tabs.StochasticOscillatorInputsTab settings={s} onChange={onChange} />;
    if (activeTab === "styles") return <Tabs.StochasticOscillatorStylesTab settings={s} onChange={onChange} />;
  }
  return null;
};
